// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchInputStyles } from "@synd/Overrides/Widgets/Header/SearchInput";
import HeaderSearch from "@synd/XDL/Icons/HeaderSearch";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, getSystemColor, styledScrollbar, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

searchInputStyles.inputWrapper = {
    css: css`
        max-width: 300px;
    `,
};

searchInputStyles.input = {
    sizeVariant: "default",
    iconProps: { src: HeaderSearch },
    cssOverrides: {
        inputSelect: css`
            font-size: ${fontConfig.regular.size}px;
        `,
    },
};

searchInputStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            background-color: ${color("common.ui1")};
            border: 1px solid ${color("common.ui2")};
            color: ${color("text.main")};
            border-radius: 8px;
            max-width: none;
            padding: 0;

            ${xScreen("lte", "md")} {
                border-radius: 0;
                border: none;
                width: 100%;
            }
        `,
    },
};

searchInputStyles.autocompleteWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        max-height: 500px;
        max-width: 768px;
        overflow: hidden;
        position: relative;

        min-width: ${({ inputWidth }: any) => `${inputWidth}px`};

        ${xScreen("lte", "md")} {
            max-height: calc(100vh - var(--headerHeight) - 74px);
            max-height: calc(100svh - var(--headerHeight) - 74px);
            max-width: none;
            min-width: none;
            width: calc(100% - 32px);
            margin: 0 auto;
            border-top: 1px solid ${color("common.border")};
            ${styledScrollbar({ width: 4 })}
        }

        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};

searchInputStyles.autocompleteColumnWrapper = searchInputStyles.autocompleteCommerceSearchWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 308px;
        padding: 12px;

        ${xScreen("lte", "md")} {
            padding-left: 0;
            width: 284px;
        }

        ${xScreen("lt", "sm")} {
            width: 100%;
        }
    `,
};

searchInputStyles.fancyScroll = {
    css: css`
        padding: 4px;
        ${xScreen("lte", "md")} {
            padding-left: 0;
        }
    `,
};

searchInputStyles.autocompleteColumnProductWrapper = {
    css: css`
        padding: 16px 4px 0 16px;
        width: 452px;

        ${({ hasContent }: any) =>
            hasContent
                ? css`
                      border-left: 1px solid ${getSystemColor("common.ui2")};
                  `
                : css`
                      ${xScreen("gte", "xl")} {
                          width: 100%;
                      }
                  `};

        ${xScreen("lte", "md")} {
            flex: 1;
            width: auto;
            height: fit-content;
        }

        ${xScreen("lt", "sm")} {
            border-left: none;
            padding: 0;
        }
    `,
};
